__turbopack_context__.v({
  "donate-amount-button": "styles-module__ZLJDBq__donate-amount-button",
  "donation-amount-row": "styles-module__ZLJDBq__donation-amount-row",
  "page-wrapper-responsive": "styles-module__ZLJDBq__page-wrapper-responsive",
  "submit-wrapper": "styles-module__ZLJDBq__submit-wrapper",
});
